const ITEMS = [
  "Linking Dreams to Destinations",
  "100% Tailor-Made Itineraries",
  "Expert Visa Assistance",
  "Fixed Group Departures",
  "Thane's Trusted Travel Agency",
  "24/7 On-Trip Support",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div data-testid="editorial-marquee" className="overflow-hidden border-y border-slate-200 bg-white py-4">
      <div className="marquee-track flex w-max items-center gap-8 pr-8">
        {[...row, ...row].map((item, i) => (
          <span key={i} className="flex items-center gap-8 whitespace-nowrap">
            <span className="font-heading text-sm font-bold tracking-[0.25em] uppercase text-navy">{item}</span>
            <span className="font-display italic text-gold text-lg leading-none">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
